export default function initScrollTo() {
    scrollOnLoad();
  
    function scrollOnLoad() {
      const target = location.hash;
      if (target.length) {
        scrollTo(target);
      }
    }
  
    function scrollTo(target) {
      libs.gsap.to(window, {
        duration: 0.9,
        scrollTo: {
          y: target,
        },
        ease: "Power2.out",
      });
    }
  
    // find all links and animate to the right position
    const links = document.querySelectorAll("a[href*='#']");
    links.forEach((link) => {
      const target = link.hash;
      if (target.length && target !== "#") {
        link.addEventListener("click", (e) => {
          if (
            location.pathname.replace(/^\//, "") ==
              link.pathname.replace(/^\//, "") &&
            location.hostname == link.hostname
          ) {
            e.preventDefault();
            scrollTo(target);
  
            // push hash in history state
            if (history.pushState) {
              history.pushState(null, null, target);
            } else {
              location.hash = target;
            }
          }
        });
      }
    });
  }
  